import { render, staticRenderFns } from "./MenuFormComponent.vue?vue&type=template&id=41d64cae&scoped=true&"
import script from "./MenuFormComponent.vue?vue&type=script&lang=js&"
export * from "./MenuFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./MenuFormComponent.vue?vue&type=style&index=0&id=41d64cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d64cae",
  null
  
)

export default component.exports